import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { ApprovalRequestStatus } from '@/lib/api/types'
import { APPROVAL_STATUS_CONFIG } from '@/lib/api/types'

interface ApprovalStatusBadgeProps {
  status: ApprovalRequestStatus
  className?: string
}

export function ApprovalStatusBadge({ status, className }: ApprovalStatusBadgeProps) {
  const config = APPROVAL_STATUS_CONFIG[status]

  return (
    <Badge
      className={cn(
        config.bgColor,
        config.darkBgColor,
        config.textColor,
        config.darkTextColor,
        'text-xs font-medium',
        className
      )}
    >
      {config.label}
    </Badge>
  )
}
